import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useLandingAuthCta } from "../hooks/useLandingAuthCta";
import { HeroFigures } from "./HeroFigures";

export function HeroSection() {
  const { t } = useTranslation("landing");
  const cta = useLandingAuthCta();

  return (
    <section className="relative isolate overflow-hidden border-b border-[#1B2622]">
      <div className="relative mx-auto max-w-[1320px] px-6 pt-16 pb-20 sm:pt-24 sm:pb-28 lg:px-10">
        <div className="grid gap-14 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:items-center lg:gap-16">
          <div className="anim-fade-up" style={{ animationDelay: "80ms" }}>
            <div className="flex items-center gap-3">
              <span className="bp-dot" aria-hidden />
              <span className="mono-label">{t("hero.eyebrow")}</span>
              <span className="hidden h-px flex-1 max-w-[120px] bg-[#1B2622] sm:block" aria-hidden />
            </div>

            <h1 className="bp-display mt-7 text-[34px] text-[#E2EDE7] sm:text-[46px] lg:text-[58px]">
              {t("hero.title")}
            </h1>
            <span className="mt-6 block h-[2px] w-20 bg-[#4CD6C4]" aria-hidden />

            <p className="mt-7 max-w-[48ch] text-[16px] leading-[1.7] text-[#9DACA4]">
              {t("hero.subtitle")}
            </p>

            <p className="mt-6 max-w-[48ch] border-l-2 border-[#4CD6C4]/60 pl-4 text-[14.5px] font-medium leading-[1.6] text-[#CDDAD3]">
              {t("hero.tagline")}
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-4">
              <Link
                to={cta.primary.href}
                className="bp-btn group inline-flex h-12 items-center gap-3 px-6 text-[13px]"
              >
                {t(cta.primary.labelKey)}
                <span className="transition-transform group-hover:translate-x-1">→</span>
              </Link>
              <a
                href="#how"
                className="bp-btn-ghost inline-flex h-12 items-center px-6 text-[13px]"
              >
                {t("hero.ctaSecondary")}
              </a>
            </div>
          </div>

          <HeroFigures />
        </div>

        <div className="mt-16 bp-rule">
          <span>Upload</span>
          <span className="text-[#4CD6C4]/70" aria-hidden>›</span>
          <span>Train</span>
          <span className="text-[#4CD6C4]/70" aria-hidden>›</span>
          <span>Deploy</span>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
